import { useFetchHelpCenterAvailableTags } from 'hooks/use-fetch-help-center-tags';
import { useHelpCenter } from 'hooks/use-help-center';
import { useCallback } from 'react';

export function useHelpCenterContact() {
  const { helpCenterRef } = useHelpCenter();
  const { data, isLoading, isError, isSuccess } = useFetchHelpCenterAvailableTags();

  const openContactForm = useCallback(
    (additionalMessage?: Record<string, string | number>) => {
      if (!helpCenterRef.current || !data) {
        return;
      }

      const messageTopics = data.map(t => ({ topic: t.label }));
      if (messageTopics) {
        helpCenterRef.current.setMessageTopics(messageTopics);
      }

      if (additionalMessage) {
        helpCenterRef.current.setAdditionalMessageInformation?.(additionalMessage);
      }

      helpCenterRef.current.form();
    },
    [helpCenterRef, data],
  );

  return { openContactForm, isSuccess, isError, isLoading };
}
